import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { WhoItIsFor } from '../components/WhoItIsFor';
import { DatabaseReactivation } from '../components/DatabaseReactivation';
import { CtaBand } from '../components/CtaBand';
import { usePageTitle } from '../hooks/usePageTitle';
export function WhoItsForPage() {
  usePageTitle('Who It Is For | Viridia Analytics');
  return <>
      <PageHeader eyebrow="Who it is for" title="Built for teams with real lead spend and no time to answer the phone." body="Team leads and broker owners running Premier Agent, Flex, Realtor.com, sign calls, and their own website traffic. If appointments are the bottleneck, this is the fix." data-id="element-513" data-mp="xv3b7k3af5l0" />
      <WhoItIsFor data-id="element-514" data-mp="jtqydhjfbk3c" />
      <DatabaseReactivation data-id="element-515" data-mp="ju93z4rz7anx" />
      <CtaBand title="Find out how many appointments your team is leaving on the table." body="We will show you the missed-lead math for your own team, plus what your unworked database is likely holding." data-id="element-516" data-mp="38mmojgm3jn9d" />
    </>;
}